module.exports = __webpack_public_path__ + "img/party_1_home-body.1a7a5253.jpg";